unit PrjFormDefault;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  WebLib.REST,
  Vcl.Controls,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  WEBLib.Buttons,
  WEBLib.ExtCtrls,
  Vcl.Imaging.pngimage,
  Vcl.Imaging.GIFImg,
  Vcl.Graphics,
  XData.Web.Client,
  XData.Web.Connection,

  HBMWebData,
  PrjClassHBMDataAccess,
  PrjClassTokenInformation;

type

  // Erweiterbar für zukünfitige WebForms
  TFormIdentifier = ( wxFrmPeridicData,
                      wxFrmNone,
                      wxFrmPrintTLNReports,
                      wxFrmPrintSPLReports,
                      wxFrmPrintProtocolReports,
                      wxFrmDescisionData,
                      wxFrmPeriodenKalkulationTLN,
                      wxFrmMainFormTLN,
                      wxFrmMainFormSPL,
                      wxFrmTLNUserSettings
                    );

  TPrjFormsDefault = class(TForm)
    WaitMessage: TWaitMessage;
    procedure btnCloseClick(Sender: TObject);
    procedure webBtnCancelClick(Sender: TObject);
    procedure webBtnSaveClick(Sender: TObject);
    { Private-Deklarationen }
  private
    FFormIdentifier: TFormIdentifier;
    FRunAsSpielleiter: boolean;
    function GetDataAccess: TPrjClassHBMDataAccess;
  protected
    function GetToken: string; virtual;
    procedure SetMenuEnable(Value: boolean = False); virtual; abstract;

    [Async]
    function LoginDlg(AWebConnection: TXDataWebConnection; ARunType: TApplicationTyp; AMessage: string = ''): boolean; async;
  public
    function StripDigits(AValue: String): String;

    [Async]
    function Done: Boolean; async; virtual;
    [Async]
    function Init: Boolean; async; virtual;
    { Public-Deklarationen }
  published
    property DataAccess: TPrjClassHBMDataAccess read GetDataAccess;
    property FormIdentifier: TFormIdentifier read FFormIdentifier write FFormIdentifier;
    property RunAsSpielleiter: boolean read FRunAsSpielleiter write FRunAsSpielleiter default false;
  protected procedure LoadDFMValues; override; end;

var
  PrjFormsDefault: TPrjFormsDefault;

implementation

uses
  HBMWebDef,
  wxBaseClassWebTools,
  PrjDialogLogin;

{$R *.dfm}


function TPrjFormsDefault.StripDigits(AValue: String): String;
var i, dFirstPos: Integer;
var boolPrevWasDigit: Boolean;
begin
  Result           := '';
  boolPrevWasDigit := false;
  dFirstPos        := 1;
  for i := 1 to Length(AValue) do
  begin
    if (AValue[i] in ['0'..'9']) or (AValue[1] = '-') or (AValue[1] = '+') then
    begin
      if not boolPrevWasDigit then
        dFirstPos := i;
      boolPrevWasDigit := true;
    end else
    begin
      if boolPrevWasDigit then
        Result := Result + Copy(AValue, dFirstPos, i - dFirstPos);
      boolPrevWasDigit := false;
    end;
  end;
  if boolPrevWasDigit then
    Result := Result + Copy(AValue, dFirstPos, Length(AValue) + 1 - dFirstPos);
end;

procedure TPrjFormsDefault.btnCloseClick(Sender: TObject);
begin
  ModalResult := mrClose;
  Close;
end;

function TPrjFormsDefault.Done: Boolean;
begin
//
end;

function TPrjFormsDefault.GetDataAccess: TPrjClassHBMDataAccess;
begin
  try
    Result := DataModule.DataAccess;
  except
    wxBaseWriteLog.Write('Exception occured in TPrjFormsDefault.GetDataAccess ',slDebug);
  end;
end;

function TPrjFormsDefault.GetToken: string;
var LTokenStorageName : string;
begin
  if not JS.IsNull(window.localStorage.getItem(DataModule.TokenInformation.TokenStorageName)) then
    Result := window.localStorage.getItem(DataModule.TokenInformation.TokenStorageName)
  else
    Result := '';
end;

function TPrjFormsDefault.Init: Boolean;
begin

end;

function TPrjFormsDefault.LoginDlg(AWebConnection: TXDataWebConnection; ARunType: TApplicationTyp; AMessage: string = ''): boolean;
var LPrjDlgLogin  : TPrjDlgLogin;
var LShowResult   : TModalResult;
var LValue        : boolean;
  procedure AfterCreate(AForm: TObject);
  begin
    if Assigned(LPrjDlgLogin) and (LPrjDlgLogin is TPrjDlgLogin) then
    begin
      window.location.hash  := 'TPrjDlgLogin';  // used to manage Back button handling to close subform
      ( LPrjDlgLogin as TPrjDlgLogin ).Init;
      ( LPrjDlgLogin as TPrjDlgLogin ).Caption  := 'Anmeldung';
    end;
  end;
  procedure AfterShowModal(AValue: TModalResult);
  var LValue: boolean;
  begin
    Lvalue := (DataModule.TokenInformation.AccessInfo[1] = 'X');
    SetMenuEnable(LValue);
    Result := true;
  end;
begin
  LPrjDlgLogin                := TPrjDlgLogin.Create(nil);
  LPrjDlgLogin.Caption        := 'Anmeldung';
  LPrjDlgLogin.WebConnection  := AWebConnection;
  LPrjDlgLogin.LoginMessage   := AMessage;

  await(TPrjDlgLogin, LPrjDlgLogin.Load);
  try
    case ARunType of
      atNone          : begin
                          LPrjDlgLogin.RunAsSpielleiter   := false;
                          LPrjDlgLogin.RunAsAdministrator := false;
                          wxBaseWriteLog.Write('TPrjFormsDefault.LoginDlg(ARunType: TApplicationTyp): boolean - no RunType passed', slError);
                        end;
      atSpielleiter   : begin
                          LPrjDlgLogin.RunAsSpielleiter   := true;
                          LPrjDlgLogin.RunAsAdministrator := false;
                        end;
      atTeilnehmer    : begin
                          LPrjDlgLogin.RunAsSpielleiter   := false;
                          LPrjDlgLogin.RunAsAdministrator := false;
                        end;
      atAdministrator : begin
                          LPrjDlgLogin.RunAsSpielleiter   := false;
                          LPrjDlgLogin.RunAsAdministrator := true;
                        end;

    end;

    LShowResult                   := await(TModalresult, LPrjDlgLogin.Execute);
    if LShowResult = mrOk then
    begin
      Lvalue := (DataModule.TokenInformation.AccessInfo[1] = 'X');
      SetMenuEnable(LValue);
      Result := true;
    end else
    begin
      Result := false;
    end;
  finally
    FreeAndNil(LPrjDlgLogin);
  end;
end;

procedure TPrjFormsDefault.webBtnCancelClick(Sender: TObject);
begin
  ModalResult := mrCancel;
  Close;
end;

procedure TPrjFormsDefault.webBtnSaveClick(Sender: TObject);
begin
  ModalResult := mrOk;
  Close;
end;

procedure TPrjFormsDefault.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WaitMessage := TWaitMessage.Create(Self);

  WaitMessage.BeforeLoadDFMValues;
  try
    Name := 'PrjFormsDefault';
    Width := 1376;
    Height := 864;
    ElementFont := efCSS;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -15;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    WaitMessage.SetParentComponent(Self);
    WaitMessage.Name := 'WaitMessage';
    WaitMessage.Left := 216;
    WaitMessage.Top := 272;
    WaitMessage.Width := 24;
    WaitMessage.Height := 24;
    WaitMessage.Opacity := 0.20000000000000000;
    WaitMessage.Picture.LoadFromFile('PrjFormDefault.WaitMessage.Picture.gif');
  finally
    WaitMessage.AfterLoadDFMValues;
  end;
end;

end.
